import { Children, useRef } from 'react';
import { RectangleBackground, StoryDataContent } from '@vfit/shared/components';
import { EffectCards, FreeMode, Keyboard, Mousewheel, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useDeviceType } from '@vfit/shared/hooks';
import { ICarouselStories } from './CarouselStoriesExperience.models';
import { getSlideSize } from './CarouselStoriesExperience.utils';
import { StoryArticleContainer } from './CarouselStoriesExperience.style';
import CarouselStoriesExperienceAnimation from './components/CarouselStoriesExperienceAnimation/CarouselStoriesExperienceAnimation';

const CarouselStoriesExperience = ({
  enableAnimationBeforeScroll,
  configuration,
  action,
  storiesArticles,
  onClickStoryArticle,
  onSwipe,
}: ICarouselStories) => {
  const { isMobile, isTablet, isBigDesktop } = useDeviceType();
  const mainContainerRef = useRef<HTMLDivElement | null>(null);

  return (
    <RectangleBackground
      data={{ ...configuration }}
      handleClick={() => action?.()}
      containerRef={mainContainerRef}
    >
      <StoryArticleContainer>
        <Swiper
          slidesPerView="auto"
          effect="slide"
          cardsEffect={{
            rotate: true,
            slideShadows: false,
          }}
          spaceBetween={32}
          freeMode={false}
          mousewheel={{
            forceToAxis: true,
          }}
          centeredSlides={isMobile}
          keyboard
          pagination={{
            bulletClass: 'swiper-pagination-bullet-exp',
            bulletActiveClass: 'swiper-pagination-bullet-active-exp',
            clickable: true,
          }}
          onSlideChange={onSwipe}
          modules={[Pagination, FreeMode, Mousewheel, Keyboard, EffectCards]}
        >
          {enableAnimationBeforeScroll && (
            <CarouselStoriesExperienceAnimation containerRef={mainContainerRef} />
          )}
          {Children.toArray(
            StoryDataContent(storiesArticles)?.map((StoryArticle, indexStoryArticle) => {
              let marginLeft = 0;
              if (indexStoryArticle === 0) {
                if (!isBigDesktop) marginLeft = 32;
                else if (isBigDesktop) marginLeft = -80;
              }
              const customSize = getSlideSize(isMobile, isTablet);
              return (
                <SwiperSlide
                  id={`${indexStoryArticle}_carouselStoriesExp`}
                  style={{
                    marginLeft,
                    ...customSize,
                    cursor: 'pointer',
                  }}
                  onClick={() => onClickStoryArticle?.(indexStoryArticle)}
                >
                  {StoryArticle}
                </SwiperSlide>
              );
            })
          )}
        </Swiper>
      </StoryArticleContainer>
    </RectangleBackground>
  );
};

export default CarouselStoriesExperience;
